import { TrackingHistoryWeb } from "./web";
import { TrackingHistoryBlockProps } from "./types";

export function TrackingHistoryWebEditor(props: TrackingHistoryBlockProps) {
  return <TrackingHistoryWeb {...props} />;
}
